<div class="mainBG">
    <!-- mblSlideBg -->
    <div class="mblSlideBg" [ngClass]="{'active': isMobileMenuActive}" *ngIf="isSignedIn">
        <div class="mblSlideBg__header">
            <!-- <img src="assets/images/logoIcon.svg" alt=""> -->
             <span></span>
            <span class="closeIcon" (click)="isMobileMenuActive = !isMobileMenuActive">
                <img src="assets/images/closeWhite.svg" alt="">
            </span>
        </div>
        <!-- mblSlideBg__menu -->
        <div class="mblSlideBg__menu">
            <ul>
                <li>
                    <a href="javascript:void(0)" routerLink="/home">
                        <label>{{'Home'| translate}}</label>
                        <img src="assets/images/menuIcon1.svg" alt="">
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" routerLink="/play-golf" routerLinkActive="active">
                        <label>{{'PlayGolf' | translate}}</label>
                        <img src="assets/images/playGolf.svg" alt="">
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" routerLink="/discover">
                        <label>{{'Discover' | translate}}</label>
                        <img src="assets/images/menuIcon2.svg" alt="">
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" (click)="navigateToSettingPage('MyBag')">
                        <label>{{'MyBag' | translate}}</label>
                        <img src="assets/images/menuIcon4.svg" alt="">
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" (click)="navigateToSettingPage('MyPartner')">
                        <label>{{'My'| translate}} <b>{{'GolfAI' | translate}}</b></label>
                        <img src="assets/images/myGolf.svg" alt="">
                    </a>
                </li>
            </ul>
            <div class="txtArea">
                <h6>{{'EnhanceYourGame' | translate}} <br>
                    {{'With' | translate}} <span>{{'GolfAI' | translate}}</span></h6>
                <p>
                    + {{'ChooseYourPartner' | translate}}<br>
                    + {{'UploadGolfBag' | translate}}<br>
                    + {{'PartnerComingSoon' | translate}}<br>
                    + {{'BetterYourGame' | translate}}<br>
                </p>
            </div>
        </div>
        <!-- mblSlideBg__menu -->
        <div class="profileBg">
            <span class="profile" (click)="navigateToSettingPage('MySettings')" [class.noImage]="!user?.imageUrl">
                <img *ngIf="user?.imageUrl" [src]="user?.imageUrl" alt="">
                <div *ngIf="!user?.imageUrl" class="profile-letter">{{user?.name?.substring(0, 2)?.toUpperCase()}}
                </div>
            </span>
            <label (click)="navigateToSettingPage('MySettings')" class="col">My Settings</label>
        </div>
    </div>
    <!-- mblSlideBg -->
    <!-- mobileMenu -->

    <div class="container golf-wrap content-area" [class.hide-header]="isSignedIn">
        <!-- topMenu -->
            <!-- <div class="topMenu" *ngIf="isSignedIn">
                <div class="logoBg">
                    <a href="javascript:void(0)" routerLink="/home" class="d-none d-md-block">
                        <img class="top-logo" src="assets/images/logo.svg" alt="Golf AI" class="d-md-none">
                    </a>
                    <span (click)="navigateToSettingPage('MySettings')" class="d-md-none">
                        <img *ngIf="user?.imageUrl" [src]="user?.imageUrl" alt="">
                        <div *ngIf="!user?.imageUrl">{{user?.name?.substring(0, 2)?.toUpperCase()}}</div>
                    </span>
                </div>
                <div class="mainLogo signed-logo">
                    <img src="assets/images/logo.svg" alt="Golf AI" class="">
                </div>
                <div class="d-inline-flex">
                    <a href="javascript:void(0)" class="mblIcon d-md-none d-inline-block"
                        (click)="isMobileMenuActive = !isMobileMenuActive">
                        <img src="assets/images/hamBugerIcon.svg" alt="">
                    </a>
                </div>
            </div> -->
            <app-header></app-header>
            
            <!-- menuBlock -->        
        <!-- topMenu -->

        
        <div class="row cont-block">
            <div class="col left_block">
                <div class="d-block h-100">
                    <router-outlet></router-outlet>
                </div>
            </div>

            <!-- voiceResponse-block -->
             <!-- bg-white voiceResponse-block -->
            <div class="col-auto chat-col">
                <app-chat-box></app-chat-box>
            </div>
            <!-- voiceResponse-block -->
        </div>
        
    </div>

    
  
</div>



<ng-template #authModal>
    <app-auth-modal 
      [inEmbeddedBrowser]="inEmbeddedBrowser"
      [page]="authPage"
      [loadCaddy]="loadCaddyData"
      (closeModal)="closeAuthModal($event)">
    </app-auth-modal>
</ng-template>